// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__PgCo4","active":"button_active__xYdl0","disabled":"button_disabled__LT2O0","title":"button_title__xEvb2","beta":"button_beta__4Q3eC"};